// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__L-eib","inner":"Footer_inner__18euq","nextIcon":"Footer_nextIcon__WtShJ","innerLeft":"Footer_innerLeft__1dU17"};